import React, {useState, useEffect} from 'react'
import {Link, navigate} from 'gatsby'
import {Container, Image, Item } from 'semantic-ui-react'
import AddToCart from '../AddToCart'
import ImageCarousel from '../Carousel/imageCarousel'
import VariantDropdown from './variantDropdown'
import OptionDropdown from './optionDropdown'
import * as styles from './styles/productSum.module.css'
import './styles/productSum.css'
import ImageZoom from '../ImageZoom'
import ImageHolder from '../ImageHolder'

export default ({
	id,
	name,
	meta,
	sku,
	orgsku,
	url,
	mainImageHref,
	organizationName,
	organizationUrl,
	images,
	variant,
	promo,
	originalProduct,
	exclusive,
	userExclusiveList,
	disabled,
	loading,
	options,
	location
}) => {
	const [itemnote, setItemNote] = useState(options !== undefined ? (options.length > 1 ? undefined: (options.length > 0 ? options[0].name: "")) : "")
	const [showConfirm, setShowConfirm] = useState(false)
	const [activeImage, setActiveImage] = useState(mainImageHref)
	const [convertedImages, setConvertedImages] = useState(images.map((item)=>{
		return {
			squareImageHref:item.thumbnail,
			mainImageHref:item.url,
		}
	}));

	const showPrompt = (quantity) =>{
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'addToCart',
			'ecommerce': {
				'add': {
					'value': parseFloat(meta.display_price.with_tax.amount)*parseInt(quantity, 10),
					'products': [
						{
							'name': name,
							'price': meta.display_price.with_tax.amount,
							'id': sku,
							'quantity':parseInt(quantity, 10),
							'item_id': sku,
							'item_name': name,
							'currency': "PHP",
						}
					]
				}
			}
		});
	}

	useEffect(()=>{
		setActiveImage(mainImageHref);
	}, [mainImageHref])

	useEffect(()=>{
		let temp = images.map((item)=>{
			return {
				squareImageHref:item.thumbnail,
				mainImageHref:item.url,
			}
		})
		setConvertedImages(temp);
	}, [images])

	const hidePrompt = () => {
		setShowConfirm(false)
	}


	const changeOption = (newnote) =>{
		setItemNote(newnote)
	}

	const changeMainImage = ({mainImageHref}) =>{
		setActiveImage(mainImageHref)
	}


	const closePrompt = () => {
		/*check in case there's no state being passed
		 *by link/navigate as in user directly went to this product page by direct url
		 */
		 /*
		 // 2020-10-02 - Try continue shopping to show related sections
		if(location.state) {

			if(location.state.cameFrom) {
				const page = location.state.cameFrom.split('-')[0]
				//not sure if order page is back button or home page or something else
				if( location.state.cameFrom && page!=="cart") {
					window.history.back();
				}else {
					navigate('/');
				}
			}else {
				navigate('/');
			}

		}else {
			navigate('/');
		}
		*/
		 // 2020-10-02 - Try continue shopping to show related sections
		setShowConfirm(false)
		document.getElementById('page-related').scrollIntoView({
			behavior: 'smooth'
		});

		//window.scrollTo({top: 0, behavior: 'smooth'});
	}
	let filteredVariant
	let currentItem
	if(variant!==undefined) {
		currentItem = variant.filter((item)=>{
			return url===item.url
		})
		filteredVariant = variant.filter((item)=>{
			return url!==item.url
		})
	}

	const [exclusiveRate, setExclusiveRate] = useState({amount: 0, formatted: "0.00", currency: "Php"});
	const {formatted: originalPriceFormatted, currency: originalPriceCurrency} = originalProduct.meta.display_price.with_tax;

	useEffect(() => {
		// Checks if user has registered to any franchise, seminar, course.
		if (userExclusiveList.length > 0) {

			// Initialize exclusive values
			let exclusivestr = "0.00";
			let exclusiveval = 0;
			let exclusivecurrency = "Php";

			// Checks if product has special rates
			if (exclusive !== undefined && exclusive.length > 0) {
				// Filter the special rates applicable to the user
				const applicablePrices = exclusive.filter((e) => {
					return userExclusiveList.includes(e.code);
				})

				// Checks if there are any applicable special rates
				if (applicablePrices.length > 0) {
					let lowestApplicablePrice = applicablePrices[0].price;

					// Find the lowest price among the applicable special rates
					for (const applicablePrice of applicablePrices) {
						if (applicablePrice < lowestApplicablePrice) {
							lowestApplicablePrice = applicablePrice.price;
						}
					}

					// Set the exclusive price to be the lowest applicable special rate
					exclusiveval = lowestApplicablePrice;
				}

				// Set values to display for special rates
				if (exclusiveval > 0) {
					exclusivestr = `${exclusiveval.toFixed(2)}`;
					setExclusiveRate({amount: exclusiveval, formatted: exclusivestr, currency: exclusivecurrency});
				}
			}
		}
	}, [userExclusiveList, exclusive])

	const [openZoomModal, setOpenZoomModal] = useState(false)

	return (
		<React.Fragment>
			<Item.Group>
				<Item className={styles.item}>
					<Item.Image size='medium'>
						<div className={`${styles.imageContainerOnMobile}`}>
							<ImageHolder
								heightToWidthRatio={1}
								src={activeImage}
								alt={name}
								className={styles.productImage}
								onClick={() => setOpenZoomModal(true)}
								/>
						</div>
						{activeImage !== "" &&
							<ImageZoom
								imageSource={activeImage}
								header={name}
								openZoomModal={openZoomModal}
								handleClose={() => setOpenZoomModal(false)}
							>
								<ImageCarousel
									items={convertedImages}
									onImageClick={changeMainImage}
									imagesAsLinks={false}
									navButtonStyle={`${styles.imgCarouselNav} ${styles.imgCarouselDesktopNav}`}
									showHeader={false}
									imageClassName={styles.imageCarouselClassName}
									selectedImageClassName={styles.selectedImage}
									selectedImage={activeImage}
									imageHeightToWidthRatio={1}
								/>
							</ImageZoom>
						}
						<Container textAlign='center'>
							<p >Click image to zoom</p>
						</Container>
						{ convertedImages.length > 1 && (
							<div className={styles.desktopOnlyMod}>
								<ImageCarousel
									items={convertedImages}
									onImageHover={changeMainImage}
									imagesAsLinks={false}
									navButtonStyle={`${styles.imgCarouselNav} ${styles.imgCarouselDesktopNav}`}
									showHeader={false}
									imageClassName={styles.imageCarouselClassName}
									selectedImageClassName={styles.selectedImage}
									selectedImage={activeImage}
									imageHeightToWidthRatio={1}
								/>
							</div>

						)}
					</Item.Image>
					<Item.Content>
						<div className={styles.mobileOnlyMod} >
							{ convertedImages.length > 1 && (
								<ImageCarousel
									items={convertedImages}
									onImageClick={changeMainImage}
									onImageHover={changeMainImage}
									imagesAsLinks={false}
									navButtonStyle={`${styles.imgCarouselNav} ${styles.imgCarouselMobileNav}`}
									showHeader={false}
									mobileShown={4}
									imageClassName={styles.imageCarouselClassName}
									selectedImage={activeImage}
									selectedImageClassName={styles.selectedImage}
									imageHeightToWidthRatio={1}
								/>
							)}
						</div>
						<Item.Header className={styles.header}><h1>{name}</h1></Item.Header>
						<Item.Description className={styles.text}>
							{(meta.display_price.with_tax.amount > 0 || exclusiveRate.amount > 0) &&
								<> { exclusiveRate.amount > 0 ?
									<Item.Meta>
										{ meta.display_price.with_tax.amount > 0 &&
											<s style={{color: "var(--content-bglight-text)"}}>{originalPriceCurrency}{originalPriceFormatted}</s>
										}
										<span style={{color: "var(--blogTextColor)"}}>{exclusiveRate.currency}{exclusiveRate.formatted}</span>
									</Item.Meta>
									: <div>{`${meta.display_price.with_tax.currency}${meta.display_price.with_tax.formatted}`}</div>
								}</>
							}
							{exclusiveRate.amount > 0 && <div>Special Rate</div>}
							{filteredVariant!==undefined && (
								<React.Fragment>
									{filteredVariant.length > 0 && (
										<div className={styles.dropdown}>
											<VariantDropdown promoItem={false} items={filteredVariant} currentItem={currentItem} productName={name}/>
										</div>
									)}
								</React.Fragment>
							)}
							{options!==undefined && (
								<React.Fragment>
									{options.length > 1 && (
										<div className={styles.dropdown}>
											<OptionDropdown updateOption={changeOption} items={options}/>
										</div>
									)}
								</React.Fragment>
							)}
							{promo!==undefined && (
								<React.Fragment>
									{promo.length > 0 && (
										<div className={styles.dropdown}>
											<VariantDropdown promoItem={true} items={promo} currentItem={currentItem} productName={name}/>
										</div>
									)}
								</React.Fragment>
							)}
							Supplier : <Link to={`/organization/${organizationUrl}/`} className={styles.link}>
								{organizationName}

							</Link>
							{(orgsku.length < 2 && organizationUrl !== "negosyonow") && <>
								&nbsp;&nbsp;&nbsp;
								<Link to={`/organization/negosyonow/`} className={styles.link}>
									(Limited Offer)
								</Link>
							</>}

						</Item.Description>

						<Item.Extra>
							<AddToCart 
								note={itemnote} 
								productId={id} 
								productName={name}
								productImage={mainImageHref}
								showPopUp={showPrompt} 
								disabled={disabled} 
								loadingProduct={loading}
							/>
						</Item.Extra>

					</Item.Content>
				</Item>
			</Item.Group>

		</React.Fragment>
	)
}
